import { vi as vi$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var vi = {
  language: 'vi',
  country: 'vn',
  name: 'Tiếng Việt',
  embeddedLocale: merge(error, login),
  flags: ['VN'],
  dateFns: vi$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { vi as default };
